import { ACTION_TYPES, MUTATION_TYPES } from './types';

import { getValidationMessages as _getValidationMessages } from '../api';
import academicYearService from './../academicyear.api';

export default {
  async getValidationMessages(context, messagesCodes) {
    const validationMessages = await _getValidationMessages(messagesCodes);
    context.commit(ACTION_TYPES.SET_VALIDATION_MESSAGES, validationMessages);
  },
  async [ACTION_TYPES.GET_CURRENT_ACADEMIC_YEAR](context) {
    if (context.state.currentAcademicYear == null) {
      const academicYear = await academicYearService.getCurrentAcademicYear();
      context.commit(MUTATION_TYPES.SET_CURRENT_ACADEMIC_YEAR, academicYear);
      sessionStorage.setItem(
        'current-academic-year',
        JSON.stringify(academicYear)
      );
    }
  },
};
